import { render, staticRenderFns } from "./signFactor.vue?vue&type=template&id=f58fe33a&scoped=true&"
import script from "./signFactor.vue?vue&type=script&lang=js&"
export * from "./signFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58fe33a",
  null
  
)

export default component.exports